/**
 * EntrepriseKpis — portail « Entreprise » (Batch #14.315).
 * Chiffres de la TENUE DE LIVRES (grand livre reporté — identiques à l'Aperçu entreprise du cabinet)
 * + rappel des pièces que le client a lui-même envoyées.
 */
import { fmtCAD } from "./_shared";

function Kpi({ tone, label, value, sub, testId }) {
  return (
    <div className={`rounded-xl p-3 ${tone}`} data-testid={testId}>
      <p className="text-[11px] opacity-75">{label}</p>
      <p className="text-lg font-bold mt-0.5 font-mono">{value}</p>
      {sub && <p className="text-[10px] opacity-60">{sub}</p>}
    </div>
  );
}

export default function EntrepriseKpis({ data, year }) {
  const b = data.books || {};
  const t = data.totals;
  const sections = data.sections;
  const net = Number(b.net || 0);
  return (
    <>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 mt-4">
        <Kpi tone="bg-emerald-50 text-emerald-800" label={`Revenus ${year}`} value={fmtCAD(b.revenues || 0)}
          sub={sections.includes("revenues") ? `${t.nb_revenues} facture(s) envoyée(s)` : "Ventes comptabilisées"} testId="ent-portal-kpi-revenues" />
        <Kpi tone="bg-rose-50 text-rose-800" label={`Dépenses ${year}`} value={fmtCAD(b.expenses || 0)}
          sub={sections.includes("expenses") ? `${t.nb_expenses} reçu(s) envoyé(s)` : "Achats comptabilisés"} testId="ent-portal-kpi-expenses" />
        <Kpi tone={net >= 0 ? "bg-blue-50 text-blue-900" : "bg-orange-50 text-orange-800"} label={`Résultat ${year}`} value={fmtCAD(net)}
          sub="Revenus − dépenses" testId="ent-portal-kpi-net" />
        {sections.includes("mileage") && (
          <Kpi tone="bg-amber-50 text-amber-800" label={`Kilométrage ${year}`} value={`${Number(b.km || 0).toLocaleString("fr-CA")} km`}
            sub={`${b.nb_mileage || 0} trajet(s) · ${fmtCAD(b.km_amount || 0)} à ${Number(b.km_rate || 0).toFixed(2)} $/km`} testId="ent-portal-kpi-km" />
        )}
      </div>
      <p className="text-[11px] text-gray-500 mt-2" data-testid="ent-portal-books-note">
        Chiffres de votre tenue de livres (exercice {b.fiscal_year?.from} → {b.fiscal_year?.to}), mis à jour par votre comptable à mesure que vos pièces sont comptabilisées.
      </p>
    </>
  );
}
